@if (!!appointment) {
  <div class="appointment-info active"
    >
    <div class="dashboard-container">
      <div class="container-fluid">
        <div class="appointment-container row">
          <div class="col-md-3 no-padding">
            <span class="appointment-start-time">
              <i class="fa"></i>
              @if (isToday(appointment.startDateTime)) {
                <span>
                  {{ 'APPOINTMENT.INFO.TODAY' | translate }} {{appointment.startDateTime | date:'HH:mm'}} {{'APPOINTMENT.INFO.TIME-MAIN-SPECIFIER' | translate}}
                </span>
              }
              @if (!isToday(appointment.startDateTime)) {
                <span>
                  {{appointment.startDateTime | date:'dd.LL.yyyy HH:mm'}} {{'APPOINTMENT.INFO.TIME-MAIN-SPECIFIER' | translate}}
                </span>
              }
            </span>
            <div class="appointment-duration">
              <span>{{appointment.period}}</span>
            </div>
            <span class="appointment-end-time">
              <i class="fa fa-dot-circle"></i> {{appointment.endDateTime | date:'HH:mm'}} {{'APPOINTMENT.INFO.TIME-MAIN-SPECIFIER' | translate}}</span>
            </div>
            <div class="col-md-7 no-padding patient-info-wrapper">
              @for (participant of (participants$| async ); track participant) {
                <div>
                  @if (!!participant) {
                    <h3>
                      {{participant.fullName}}
                    </h3>
                  }
                </div>
              }
              <div class="patient-info clearfix">
                <div class="online-status-bubble"></div>
                <span> {{ patientStatusName$ | async }} </span>
                <span class='tan' ngxClipboard
                [cbContent]="getTanLoginLink(appointment.tan)" (click)="copiedSuccessfully()">{{appointment.tan}}</span>
                @for (participant of (participants$| async ); track participant) {
                  @if (!!participant && !!participant.insuranceNumber) {
                    <span>
                      {{ participant.insuranceNumber }}
                    </span>
                  }
                }
              </div>
              @if (!hideCopiedSuccessfully) {
                <div class="show-copied-tan">
                  {{ 'APPOINTMENT.TAN-CREATE-SUCCESSFUL.TAN-COPIED' | translate }}
                </div>
              }
              @for (participant of (participants$| async ) ; track participant) {
                <div>
                  @if (!!participant && !!participant.email) {
                    <div class='email-holder'>
                      <a href="mailto:{{participant.email}}">
                        <i class="fa fa-envelope email-space"></i>{{ participant.email }}
                      </a>
                    </div>
                  }
                </div>
              }
              @if (appointment.appointmentMessage) {
                <div class="message">
                  <span class="bold">{{ 'APPOINTMENT.INFO.APPOINTMENT_MESSAGE' | translate }}: </span>
                  {{ appointment.appointmentMessage }}
                </div>
              }
              @if (isAllowToShowCallNow()) {
                <button class="button btn-primary call-now"
                  (click)="startVideoCall()">
                  <span><i class="fa fa-caret-right"></i>{{ 'APPOINTMENT.INFO.START' | translate }}</span>
                </button>
              }
              @if (isAllowShowToGoToWaitingRoom()) {
                <button class="button btn-primary goto-waitingroom"
                  (click)="goToWaitingRoom()">
                  <span>{{ 'APPOINTMENT.INFO.GOTO_WAITINGROOM' | translate }}</span>
                </button>
              }
            </div>
            <div class="col-md-2 no-padding">
              @for (participant of (participants$| async ); track participant) {
                <div>
                  @if (!!participant && !!participant.email) {
                    <div class='action-icons'>
                      <a href="mailto:{{participant.email}}" placement="bottom"
                        ngbTooltip="{{participant.email}}">
                        <i class="fa fa-envelope"></i>
                      </a>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }
